import React from 'react';
import ErrorPage from '../ErrorPage';
import { reportBoundaryError, ERROR_BOUNDARY_NAMES } from '../../utils/errorReporting';

class ErrorBoundary extends React.Component {
    constructor(props) {
        super(props);
        this.state = { error: null, errorInfo: null };
    }

    componentDidCatch(error, errorInfo) {
        reportBoundaryError(error, errorInfo, { boundary: ERROR_BOUNDARY_NAMES.APP });
        this.setState({
            error,
            errorInfo,
        });
    }

    render() {
        const { main } = this.props;
        const { errorInfo } = this.state;

        if (errorInfo) {
            // Error path
            return (
                <ErrorPage
                    isFullPage={main}
                    showReloadButton={true}
                    showBackButton={false}
                    data-testid="error-boundary.error-page"
                />
            );
        }
        // Normally, just render children
        return this.props.children;
    }
}

export default ErrorBoundary;
